export default __webpack_public_path__ + "static/media/54.d21144b2.jpg";